<script setup lang="ts" generic="TColumn">
import {
  computed,
} from 'vue';

import { useAppBreakpoints } from '@modules/core/composables/breakpoints';

import type {
  ITableEmits,
  ITableProps,
  ITableSlots,
} from './types';
import VTableDesktop from '../VTableDesktop/VTableDesktop.vue';
import VTableMobile from '../VTableMobile/VTableMobile.vue';

const props = withDefaults(defineProps<ITableProps<TColumn>>(), {
  refreshButton: true,
});
const emit = defineEmits<ITableEmits>();
const slots = defineSlots<ITableSlots<TColumn>>();

const { md } = useAppBreakpoints();

const TableComponent = computed(() => (md.value ? VTableDesktop : VTableMobile));
</script>

<template>
  <component v-data-qa-auto-id="'VTable'"
    :is="TableComponent"
    v-memo="[
      TableComponent,
      props.data,
      props.filterProps,
      props.multiselect,
      props.selectedIds,
      props.columnsOptions,
      props.state,
      props.loading,
      props.isFetching,
      props.disableAllControls,
      props.titleTPath,
      props.subtotalEnabled,
    ]"
    v-bind="props"
    @state-update="(state, action) => emit('state-update', state, action)"
    @multiselect-action="(data) => emit('multiselect-action', data)"
    @selections-change="(ids) => emit('selections-change', ids)"
    @refresh="(state) => emit('refresh', state)"
  >
    <template
      v-for="(_, name) in slots"
      :key="name"
      #[name]="slotProps"
    >
      <!-- @vue-ignore -->
      <slot
        :name="name"
        v-bind="slotProps"
      />
    </template>
  </component>
</template>
